import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

// A protected route component
const ProtectedRoute = ({ children, allowedRoles }) => {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    // Get user role or admin status from localStorage
    const storedRole = localStorage.getItem('isAdmin'); // Ensure you're storing 'isAdmin' correctly
    setRole(storedRole);
    setLoading(false); // Set loading to false once data is fetched
  }, []);

  // Show loading screen if data is still being fetched
  if (loading) {
    return <div>Loading...</div>; // You can replace this with a spinner or more detailed loading message
  }

  // If the role is not available or doesn't match, redirect to login page
  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to="/login" />; // Redirect to login page (or another page as per your app)
  }

  // Otherwise, render the children (the protected route content)
  return children;
};

export default ProtectedRoute;
